import { render } from "./CIS-Tabs-Secondary-Tab.vue?vue&type=template&id=577f59fc&scoped=true"
import script from "./CIS-Tabs-Secondary-Tab.vue?vue&type=script&lang=js"
export * from "./CIS-Tabs-Secondary-Tab.vue?vue&type=script&lang=js"

import "./CIS-Tabs-Secondary-Tab.vue?vue&type=style&index=0&id=577f59fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577f59fc"]])

export default __exports__